import { createSlice } from '@reduxjs/toolkit'
import { fetchAllPlayers, fetchPlayerDetails, fetchPlayerGameWiseReport } from 'redux-thunk/thunk/Players/players'

const initialState = {
  allPlayers: null,
  playerDetail: null,
  playerGameWiseReport: null
}

const playerSlice = createSlice({
  name: 'playerSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPlayers.fulfilled, (state, action) => {
        return {
          ...state,
          allPlayers: action.payload
        }
      })
      .addCase(fetchPlayerDetails.pending, (state) => {
        return {
          ...state,
          playerGameWiseReport: null
        }
      })
      .addCase(fetchPlayerDetails.fulfilled, (state, action) => {
        return {
          ...state,
          playerDetail: action.payload
        }
      })
      .addCase(fetchPlayerGameWiseReport.fulfilled, (state, action) => {
        return {
          ...state,
          playerGameWiseReport: action.payload
        }
      })
  }
})

export default playerSlice.reducer
